import {
  BodyStyles,
  CreditApplication,
  PricingAggregates,
  TradeInStatus
} from '~/contracts/flp';
import {
  getDownPaymentDropdownOptions,
  getMonthlyPaymentDropdownOptions
} from '~/utilities/flp/getShopByOptions';

/**
 * Utilities for mapping API response data to domain objects for state management.
 */
export const reducer = {
  aggregates: ({
    bodyStyles,
    financeInfo,
    downPaymentBuckets,
    ...rest
  }: PricingAggregates) => {
    return {
      ...rest,
      bodyStyles: bodyStyles?.map(style => ({
        ...style,
        // force lowercase name to ensure UI keys map correctly
        name: style?.name?.toLowerCase() as BodyStyles
      })),
      downPaymentBuckets:
        downPaymentBuckets?.sort((a, b) => a.downPayment - b.downPayment) || [],
      downPaymentDropdownOptions: getDownPaymentDropdownOptions(
        financeInfo?.minDownPayment
      ),
      monthlyPaymentDropdownOptions: getMonthlyPaymentDropdownOptions(
        financeInfo?.maxMonthlyPayment
      )
    };
  },

  cosigner: (creditApplication: CreditApplication | undefined) => {
    if (!creditApplication?.coApplicantEligibility?.coSignerAllowed) {
      return null;
    }

    return {
      enabled: creditApplication?.coApplicantToggleOn ?? false,
      error: null,
      data: creditApplication?.hasCoApplicant
        ? creditApplication?.coapplicant
        : null
    };
  },

  financeterms: (
    pricingAggregates: PricingAggregates,
    creditApplication: CreditApplication
  ) => {
    return {
      ...pricingAggregates?.financeInfo,
      expiration: creditApplication?.creditApplicationExpirationUtc ?? ''
    };
  },

  tradein: (pricingAggregates: PricingAggregates) => {
    const { tradeInfo, error } = pricingAggregates;
    const status = tradeInfo?.status
      ? (String(tradeInfo.status).toLowerCase() as TradeInStatus)
      : TradeInStatus.NotSet;

    const shouldShowTrade = [
      TradeInStatus.Active,
      TradeInStatus.Expired
    ].includes(status);

    return {
      enabled: shouldShowTrade,
      data: shouldShowTrade ? tradeInfo : null,
      error: error || null
    };
  }
};
